import { useState } from 'react'

import { Viewport } from './accountModel'
import { AccountShell } from './AccountShell'
import { AgentAvatar } from './AgentAvatar'
import { AgentChatModal } from './AgentChatModal'
import { BottomNav } from './BottomNav'

/**
 * The web app on a phone. No native app at MVP, so this is the only place a
 * driver meets the agent away from a desk.
 */
export function MvpMobilePlacement({ className }: { className?: string }) {
  const [open, setOpen] = useState(false)
  const toggle = () => setOpen((was) => !was)

  return (
    <AccountShell
      viewport={Viewport.MOBILE}
      topNavCenter={<AgentAvatar active={open} onClick={toggle} />}
      overlay={open && <AgentChatModal onClose={() => setOpen(false)} />}
      bottomNav={<BottomNav onToggle={toggle} active={open} />}
      className={className}
    />
  )
}
